import { Button } from "@sellar-io/components";
import { ReactElement, useState } from "react";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { useOrderAssignRouteDefinition } from "~/hooks/api/v2/order/useOrderAssignRouteDefinition";
import { apiV2AssertError } from "~/hooks/api/v2/apiV2Request";
import { Alert } from "~/components/alert/Alert";

export function OrderAssignRouteAndCreateCTTaskDialog({
  active,
  orderId,
  onDismiss,
}: {
  active: boolean;

  orderId: number;
  onDismiss: () => void;
}): ReactElement {
  const mutation = useOrderAssignRouteDefinition(orderId);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const onConfirm = async () => {
    setErrorMessage("");
    mutation.mutate(undefined, {
      onSuccess: () => {
        onDismiss();
      },
      onError: (error) => {
        const message = apiV2AssertError(error)?.response?.data.message;
        setErrorMessage(message ?? "An unknown error occurred");
      },
    });
  };

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title="Assign a route definition"
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />

      <DialogContent className="flex flex-col gap-4">
        {errorMessage && <Alert type="error" message={errorMessage} />}
        <p>
          Are you sure you want to assign a route definition to order{" "}
          <strong>#{orderId}</strong> and create a task on Control Tower?
          <br />
          <br />
          Only use this if you know what you're doing, otherwise contact the
          product team.
        </p>
      </DialogContent>
      <DialogCTA>
        <Button onClick={onConfirm} loading={mutation.isPending}>
          Assign
        </Button>
      </DialogCTA>
    </Dialog>
  );
}
